






























































































































































































import { Component, Vue } from 'vue-property-decorator';
import { SmartQuery } from 'vue-apollo-decorator';
import { GQL_getAmelding_amelding } from '@/queries/__generated__/getAmelding';
import AmeldingListWorkRelation from './AmeldingListWorkRelation.vue';
import AmeldingListPaycheck from './AmeldingListPaycheck.vue';
import XmlPolisher from '@/components/XmlPolisher.vue';
import JsonPolisher from '@/components/JsonPolisher.vue';
import gql from 'graphql-tag';

const GET_AMELDING = gql`
  query getAmelding($id: ID!) {
    amelding(id: $id) {
      id
      calendarMonth
      ameldingReference
      humanStatus
      altinnSubmission {
        id
        sentAt
        processedAt
        correspondenceTitle
      }
      altinn3Submission {
        id
        sentAt
        sendingStatus
        pending
        sentBy {
          id
          name
        }
      }
      ameldingWorkRelations {
        id
        workRelation {
          id
          employmentType
          employmentPercentage
          employee {
            id
            firstName
            lastName
          }
          occupation {
            id
            name
          }
        }
        ameldingWorkRelationLeaveAndLayoffs {
          id
          workRelationLeaveAndLayoff {
            id
            startDate
            endDate
            description
          }
        }
      }
      paychecks {
        id
        number
      }
      aMeldingXml {
        id
        content
      }
      aMeldingJson {
        id
        content
      }
      feedbackXml {
        id
        content
      }
      feedbackJson {
        id
        content
      }
      feedbackDeviations {
        month
        subUnitOrgno
        subUnitName
        incomeReceiverSsn
        incomeReceiverName
        deviationId
        name
        severity
        details
      }
      failureMessage
    }
  }
`;

@Component({
  components: {
    AmeldingListWorkRelation,
    AmeldingListPaycheck,
    XmlPolisher,
    JsonPolisher,
  },
})
export default class AmeldingsShow extends Vue {
  @SmartQuery({
    query: GET_AMELDING,
    fetchPolicy: 'no-cache',
    variables() {
      return { id: this.$route.params.id };
    },
  }) private amelding!: GQL_getAmelding_amelding;

  private viewSentAttachment = false;
  private showReceivedXML = false;
  private showReceivedJSON = false;
  private showFeedbackDeviations = false;

  private get submission() {
    return (this.amelding.altinnSubmission || this.amelding.altinn3Submission);
  }

  private get isAltinn3() {
    return !!this.amelding?.altinn3Submission;
  }

  private get isAltinnOld() {
    return !!this.amelding?.altinnSubmission;
  }
}
